// src/api.js
import axios from 'axios';

const api = axios.create({
  baseURL: 'https://pamp-damp.ru/api/', // замените на URL вашего Django API
  timeout: 10000,
});

// Если нужен CORS, убедитесь, что ваш Django настроен через django-cors-headers

export default api;